import { Button, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({}));

export function useCourses() {
  const [courses, setCourses] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/courses')
      .then((response) => response.json())
      .then((data) => {
        setCourses(data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { courses, setCourses };
}

export default function Courses() {
  const { courses, setCourses } = useCourses();
  const [numericName, setNumericName] = React.useState('');
  const [alphaName, setAlphaName] = React.useState('');
  const [grade, setGrade] = React.useState('');
  const [selectedCourse, setSelectedCourse] = React.useState(null);
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/courses-update/${id}`);
  };

  const columns = [
    {
      name: 'numericName',
      label: 'Nombre Numérico',
    },
    {
      name: 'alphaName',
      label: 'Nombre Alfabético',
    },
    {
      name: 'grade.name',
      label: 'Grado',
    },
    {
      name: 'createdAt',
      label: 'Fecha De Creación',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(courses[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar las asignaturas seleccionadas?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/courses/${
            courses[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        let data = await response.json();
        if (data.success) {
          setCourses(courses.splice(row?.dataIndex, 1));
          setNumericName('');
          setAlphaName('');
          setGrade('');
        }
      });
    }
  };

  useEffect(() => {
    if (selectedCourse) {
      setNumericName(selectedCourse?.numericName);
      setAlphaName(selectedCourse?.alphaName);
      setGrade(selectedCourse?.grade?._id);
    }
  }, [selectedCourse]);

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás visualizar la lista de
        cursos creados en la plataforma, desde esta sección podrá gestionar cada
        uno de ellos, ten mucha precaución de eliminar algún curso, si ya cuenta
        con asociaciones, este proceso no se puede recuperar.
      </p>
      <MUIDataTable
        title={'Listado de cursos'}
        data={courses}
        columns={columns}
        options={{
          filter: 'dropdown',
          enableNestedDataAccess: '.',
          onRowsDelete: (rowsDeleted) => {
            handleDelete(rowsDeleted);
          },
        }}
      />
    </div>
  );
}
